import { useState } from "react";
import styled from "styled-components";

import Overlay from "../../../Componentes/Overlay";
import Modal from "../../../Componentes/Utils/Modal";
import { useToast } from "../../../contexts/ToastContext";
import useApi from "../../../hooks/useApi";
import { formatarDataHora, formatResultadoTeste, formatTipoTeste } from "./utils";

const Titulo = styled.h2`
    margin: 0 0 10px 0;
    font-size: 17px;
    color: #263b4b;
    text-align: center;
`;

const Subtitulo = styled.p`
    margin: 0;
    font-size: 14px;
    color: #555;
    text-align: center;
    line-height: 1.5;
`;

const Resumo = styled.div`
    margin: 16px 0 0 0;
    padding: 12px;
    background-color: #f5f7fa;
    border: 1px solid rgba(0, 0, 0, 0.08);
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    gap: 4px;
    font-size: 13px;
    color: #111;

    p { margin: 0; }
    b { color: #263b4b; }
`;

const BotoesWrapper = styled.div`
    margin-top: 24px;
    display: flex;
    justify-content: flex-end;
    gap: 10px;
`;

const Botao = styled.button`
    padding: 9px 16px;
    background-color: ${(p) => (p.$cancel ? "#e5e7eb" : "#e11d48")};
    color: ${(p) => (p.$cancel ? "#333" : "white")};
    border: none;
    border-radius: 6px;
    font-weight: 600;
    font-size: 13px;
    cursor: pointer;
    transition: background-color 0.15s ease;

    &:hover:not(:disabled) {
        background-color: ${(p) => (p.$cancel ? "#d1d5db" : "#be123c")};
    }

    &:disabled { opacity: 0.6; cursor: not-allowed; }
`;

const ModalDeleteTeste = ({ teste, fecharModal, onDeleted }) => {
    const api = useApi();
    const { notifyError, notifySuccess } = useToast();
    const [removendo, setRemovendo] = useState(false);

    const handleDelete = async () => {
        if (!teste?.id) return;
        setRemovendo(true);
        try {
            const { data } = await api.post(
                "/Painel/API/AtendimentoAmb/TestesAlcoolDrogas/Delete/index.php",
                { id: teste.id }
            );
            if (data?.success) {
                notifySuccess(data?.message || "Teste removido.");
                if (onDeleted) await onDeleted();
                fecharModal();
                return;
            }
            notifyError(data?.message || "Não foi possível remover.");
        } catch (err) {
            console.error(err);
            notifyError(err?.response?.data?.message || "Erro ao remover teste.");
        } finally {
            setRemovendo(false);
        }
    };

    return (
        <Overlay state>
            <Modal size="sm">
                <Titulo>Confirmar exclusão</Titulo>
                <Subtitulo>Tem certeza que deseja remover este registro de teste?</Subtitulo>

                {teste && (
                    <Resumo>
                        <p><b>ID:</b> {teste.id}</p>
                        <p><b>COLABORADOR:</b> {teste.nome}</p>
                        <p><b>TIPO:</b> {formatTipoTeste(teste.tipo_teste)}</p>
                        <p><b>RESULTADO:</b> {formatResultadoTeste(teste.resultado)}</p>
                        <p><b>DATA/HORA:</b> {formatarDataHora(teste.data_hora)}</p>
                    </Resumo>
                )}

                <BotoesWrapper>
                    <Botao type="button" $cancel onClick={fecharModal} disabled={removendo}>
                        CANCELAR
                    </Botao>
                    <Botao type="button" onClick={handleDelete} disabled={removendo}>
                        {removendo ? "REMOVENDO…" : "REMOVER"}
                    </Botao>
                </BotoesWrapper>
            </Modal>
        </Overlay>
    );
};

export default ModalDeleteTeste;
